import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from '../../../environment/utils';
import Icon from '../../../icons/components/Icon';
import { IconInfo, IconRadioButtonChecked, IconRadioButtonUnchecked } from '../../../icons/svg';
import Tooltip from '../../../tooltip/components/Tooltip';
import { getBrandingColorPalette } from '../../../styles';
const useStyles = makeStyles()(() => {
    return {
        formControl: {
            color: '#fff',
            cursor: 'pointer',
            display: 'flex',
            fontSize: '14px',
            lineHeight: '20px',
            position: 'relative',
            alignItems: 'center',
            gap: '5px',
            padding: '5px',
            '&.is-mobile': {
                fontSize: '18px',
                lineHeight: '24px'
            },
            '& input[type="radio"]': {
                appearance: 'none',
                backgroundColor: 'transparent',
                cursor: 'pointer',
                margin: 0,
                position: 'absolute',
                height: '100%',
                width: '100%',
                zIndex: 1,
                '&:checked + .radiomark': {
                    display: 'block'
                },
                '&:not(:checked) + .radiomark': {
                    display: 'none'
                },
                '&:checked ~ .radiomark-unchecked': {
                    display: 'none'
                },
                '&:not(:checked) ~ .radiomark-unchecked': {
                    display: 'block'
                }
            }
        },
        activeArea: {
            alignItems: 'center',
            borderRadius: '3px',
            display: 'flex',
            height: '8px',
            justifyContent: 'center',
            position: 'relative',
            width: '24px',
            '&.is-mobile': {
                height: '32px',
                width: '32px'
            }
        },
        disabled: {
            cursor: 'default',
            '& input[type="radio"]': {
                cursor: 'default'
            }
        }
    };
});
const RadioButton = ({ checked, className, disabled, tooltipContent, tooltipposition, label, name, interfaceConfig, value, onChange }) => {
    var _a, _b, _c, _d;
    const { classes: styles, cx } = useStyles();
    const isMobile = isMobileBrowser();
    return (React.createElement("label", { className: cx(styles.formControl, isMobile && 'is-mobile', className) },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: cx(styles.activeArea, isMobile && 'is-mobile', disabled && styles.disabled) },
                React.createElement("input", { checked: checked, disabled: disabled, name: name, onChange: onChange, type: 'radio', value: value }),
                React.createElement(Icon, { "aria-hidden": true, className: 'radiomark', color: (interfaceConfig === null || interfaceConfig === void 0 ? void 0 : interfaceConfig.applyMeetingSettings) ? (_a = getBrandingColorPalette(interfaceConfig)) === null || _a === void 0 ? void 0 : _a.accent1 : disabled ? "#858585" : "blue", size: 18, src: IconRadioButtonChecked }),
                React.createElement(Icon, { "aria-hidden": true, className: 'radiomark-unchecked', color: (interfaceConfig === null || interfaceConfig === void 0 ? void 0 : interfaceConfig.applyMeetingSettings) ? (_b = getBrandingColorPalette(interfaceConfig)) === null || _b === void 0 ? void 0 : _b.accent1 : disabled ? "#858585" : "#fff", size: 18, src: IconRadioButtonUnchecked })),
            React.createElement("div", { style: { color: (interfaceConfig === null || interfaceConfig === void 0 ? void 0 : interfaceConfig.applyMeetingSettings) ? (_c = getBrandingColorPalette(interfaceConfig)) === null || _c === void 0 ? void 0 : _c.accent1 : '#fff' } }, label)),
        tooltipContent && React.createElement("div", null,
            React.createElement(Tooltip, { content: tooltipContent, position: tooltipposition },
                React.createElement(Icon, { src: IconInfo, color: (interfaceConfig === null || interfaceConfig === void 0 ? void 0 : interfaceConfig.applyMeetingSettings) ? (_d = getBrandingColorPalette(interfaceConfig)) === null || _d === void 0 ? void 0 : _d.accent1 : disabled ? "#858585" : "#fff", size: 15 })))));
};
export default RadioButton;
